import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import {
  DownloadSingleReportConfig,
  manageOrderRowsData,
  orderSourceConfig,
  orderStatusConfig,
} from "../../types/types";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { capitalize, capitalizeFirstLetter } from "../../utils/utils";
import { ReactComponent as DownloadAllIcon } from "../../assets/image/svg/downloadAllWhite.svg";
import {
  Alert,
  Button,
  Snackbar,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Tooltip,
} from "@mui/material";
import {
    getBulkOpertionData,
  getOrderListWithType,
  getOrderInvoiceDataWithType,
  getUTCDate,
  generateBulkInvoice,
  createInvoice,
  calculateBulkInvoiceSummaryUsingStockValidate,
  aggregateStockSummary,
  getStockValidateResponse,
} from "../../services/manageOrderService";
import { downloadAllReportsPrimarySecondary, downloadSingleReport } from "../../services/manageReportService";
import "./ManageSecondaryOrderV2.css";
import "../viewOrder/ViewOrder.css";
import "../manageBasket/ManageBasket.css";
import { Loader } from "../../components/loader/Loader";
import Header from "../../components/dms_common/Header";
import CustomDataGrid from "../../components/dms_common/CustomDataGrid";
import { useSearchParams, useLocation } from "react-router-dom";
import {
  getDownloadSingleReportConfig,
  getOrderSource,
  manageOrderColumnsV2MetaData,
  performStockCheck,
  performStockCheckForBulkInvoicing,
  sortByCreationTime,
  sortBySatus,
  StockCheckResult,
} from "./ManageSecondaryOrderUtils";
import {
  filterData,
  getMultipleFilterBasedData,
  searchWithStatusFilter,
  updateDatesInLocalStorage,
} from "../../components/dms_common/DmsCommonServices";
import {
  isGapMoreThanNDays,
  isStartDateIsGreaterThanEndDate,
} from "../../utils/calenderUtils";
import { getConfigData } from "../../services/configurationService";
import {
  formatAmount,
  getButtonOnClick,
  getDisabledButtonSx,
  isUserAllowedToEdit,
  safeStringify,
  truncateString
} from "../../components/dms_common/DmsUtils";
import ScreenOverlay from "../../components/dms_common/ScreenOverlay";
import {
  createAndDownloadInvoicePdf,
  GenericModal,
  getGenericModalProps,
  initialGenericModalProps,
  printBulkInvoicePdfCokeNp,
} from "../viewOrder/ViewOrderUtils";
import CustomGenericModal from "../../components/dms_common/CustomGenericModal";
import useSessionStorageDates from "../../components/dms_common/UseSessionStorageDates";
import BulkConfirm, { BulkOrderMapType, orderStatusMap } from "./BulkConfirm";
import { analytics, logLoadTrace, performance } from "../../firebase";
import { logEvent } from "firebase/analytics";
import { trace, PerformanceTrace } from "firebase/performance";
import { sendSlackAlert, SlackChannel } from "../../services/slackService";
import { useNavigate } from "react-router-dom";
import { getDataFromLocalDb } from "../../services/dbService";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import HeaderV2 from "../../components/dms_common/HeaderV2";
import GenericSummaryCard, { GenericSummaryCardItemObject } from "../../components/dms_common/GenericSummaryCard";
import TextSwitcher, { TextSwitcherItemObject } from "../../components/dms_common/TextSwitcher";
import { getAccessToken } from "../../services/authenticationService";
import { BulkStatus, determineBulkStatus, initialBulkStatusMap, showProgressInitialState } from "./BulkUtils";
import { CustomBulkModal } from "../../components/dms_common/CustomBulkModal";
import BulkProgress from "./BulkProgress";
import { defaultRangesConfig, RangeConfig } from "../../components/dms_common/QuickDateRangePicker";
import { fetchBatchWiseStock } from "../stocks/RealTimeStock/RealTimeStockUtils";
import FormHeader from "../../components/dms_common/FormHeader";
export const CancelledInvoiceFlagging: React.FC = () => {
  return (
    <div className="CancelledInvoice_Flagging">
      <span>Invoiced</span>
    </div>
  );
};

const ManageSecondaryOrderV2 = () => {
  const ACCESS_TOKEN = getAccessToken() ?? "";
  const ConfigDictionary = JSON.parse(
    localStorage.getItem("ConfigDictionary") ?? "{}"
  );
  const startDateAtLastNDays = ConfigDictionary?.startDateAtLastNDays ?? 0; // 0 = today

  const newStartDate = dayjs().subtract(startDateAtLastNDays, "day")
  const { storedStartDate, storedEndDate, storeSessionStorageDates } =
    useSessionStorageDates("manageOrders", newStartDate);
  
  const isBulkOrderConfirmAllowed =
    useRef<boolean>(false);
  const [lastRefreshed, setLastRefreshed] = useState<Dayjs>(dayjs());
  const [isProcessing, setIsProcessing] = useState(false);
  const [viewBulkConfirm, setViewBulkConfirm] = useState<boolean>(false);
  const [data, setData] = useState<manageOrderRowsData[]>([]);
  const [rows, setRows] = useState<manageOrderRowsData[]>([]);
  const [initialOrderData, setInitialOrderData] = useState<manageOrderRowsData[]>([]);
  const [orderTrackingStagesList, setOrderTrackingStagesList] = useState<
    orderStatusConfig[]
  >([]);
  const routeIdNameMappingRef = useRef<any>({});
  const outletListRef = useRef<any>({});
  const [startDate, setStartDate] = useState<Dayjs>(storedStartDate);
  const [endDate, setEndDate] = useState<Dayjs>(storedEndDate);
  const [loader, setLoader] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const allOrdersReportIdRef = useRef<string | null>(null);
  const singleOrderReportIdRef = useRef<string | null>(null);
  const orderSourcesRef = useRef<Record<string, orderSourceConfig>>({});
  const useNewOrderStatusUpdateAPI = useRef<boolean>(false);
  const [searchedValue, setSearchedValue] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<string>("ALL");
  const [downloadSingleReportConfig, setDownloadSingleReportConfig] =
    useState<DownloadSingleReportConfig | null>();
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(
    initialGenericModalProps
  );
  const [resetSearch, setResetSearch] = useState(false);
  const [filterKeys, setFilterKeys] = useState<string[]>([]); 
  const [stockValidateResponse, setStockValidateResponse] = useState<any>({}); 
  const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>(() => {
    const stored = localStorage.getItem('multipleFiltersListManageOrders');
    return stored ? JSON.parse(stored) : {};
  });
  const [multipleFiltersVisible, setMultipleFiltersVisible] =
    useState<boolean>(false);

  const [multipleFiltersList, setMultipleFiltersList] = useState<
    Record<string, Record<string, number>>
  >({});
  const [selectedFilterType, setSelectedFilterType] = useState("status");
  const [filterSearchValue, setFilterSearchValue] = useState<string>("");
  const disableStockCheck = useRef<boolean>(false);
  const disableOrderEdit = useRef<boolean>(false);
  const fetchLimitedOrderData = useRef<boolean>(false);
  const sequentialInvoicing = useRef<boolean>(false);
  const orderConfirmationEnabled = useRef<boolean>(true);
  const navigate = useNavigate();
  const feature = "Sale";
  const pageID = "ManageOrder";
  const [disableOrderEditDesignationBased, setDisableOrderEditDesignationBased] = useState<boolean>(false);
  const [orderEditAllowedRoles, setOrderEditAllowedRoles] = useState<string[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [appliedStatusFromQuery, setAppliedStatusFromQuery] = useState<boolean>(false);
  const itemObjects = useRef<GenericSummaryCardItemObject[]>();
  const [textSwitcherItems, setTextSwitcherItems] = useState<TextSwitcherItemObject[]>([]);
  const performStockCheckManageOrder = useRef<boolean>(true);
  
  const [sortByColumn, setSortByColumn] = useState<any>();
  const [checkedRows, setCheckedRows] = useState<string[]>([]);
  const [sortedPendingOrderNumbers, setSortedPendingOrderNumbers] = useState<string[]>([]);
  const [printInvoicesLoading, setPrintInvoicesLoading] = useState<boolean>(false)
  const [invoiceNumbers, setInvoiceNumbers] = useState<string[]>([]);
  const [pendingOrderNumbers, setPendingOrderNumbers] = useState<string[]>([])
  const [pendingOrderDataForBulkButton, setPendingOrderDataForBulkButton] = useState<manageOrderRowsData[]>([])
  const { multipleCategoryFilterEnabled, useKafkaBulkFlow } = ConfigDictionary;
  const manageSecondaryOrderV2 = ConfigDictionary?.manageSecondaryOrderV2 ?? false;
  const validDateRange = ConfigDictionary.dateRangeConfig ?? 31;
  const currencySymbol = ConfigDictionary.currency;
  const bulkType = "invoice";
  const rangesConfig: RangeConfig[] = ConfigDictionary.quickDateRanges ?? defaultRangesConfig;
  const ranges = React.useMemo(
    () =>
      rangesConfig.map(({ label, days }) => ({
        label,
        days,
        getRange: (): [Dayjs, Dayjs] => {
          if (days === 0) return [dayjs().startOf("day"), dayjs().endOf("day")];
          return [dayjs().subtract(days, "day").startOf("day"), dayjs().endOf("day")];
        },
      })),
    []
  );

  const daysCount = startDate && endDate ? endDate.diff(startDate, 'day') : 0;
  const label = (ranges.find(r => r.days === daysCount)?.label || "selected Date Range");

  const [dateRangeLabel, setDateRangeLabel] = useState<string>(label);

  const [skuReplacementConfigValue, setSkuReplacementConfigValue] = useState<string>("");
  const [summaryInvoicableCount, setSummaryInvoicableCount] = useState<number>(0);
  const [summaryPartiallyInvoicableCount, setSummaryPartiallyInvoicableCount] = useState<number>(0);
  const [summaryUnavailableCount, setSummaryUnavailableCount] = useState<number>(0);
  const stockAllocationAllowed = useRef<boolean>(false)
  const initialFilterKeys= useRef<string[]>([])

  const location = useLocation();
  const isBulkPanel = useRef<boolean>(location.state?.isBulkPanel ?? false);

  const ALLOWED_PATHS = ["/viewOrder", "/viewInvoice"];

  // useEffect(() => {
  //   const handleRouteChange = () => {
  //     const path = window.location.pathname;

  //     // If we are leaving current page to anywhere NOT allowed, reset sessionStorage
  //     const isAllowed = ALLOWED_PATHS.some((allowed) => path.includes(allowed));

  //     if (!isAllowed) {
  //       sessionStorage.removeItem("bulkInvoiceFilterData");
  //     }
  //   };

  //   // Listen for React Router location changes
  //   handleRouteChange(); // run on mount in case we are already on an allowed path
  // }, [location.pathname]); // re-run on every route change

  useEffect(() => {
    const clearOnRefresh = () => {
      sessionStorage.removeItem("bulkInvoiceFilterData");
    };

    window.addEventListener("beforeunload", clearOnRefresh);

    return () => {
      window.removeEventListener("beforeunload", clearOnRefresh);
    };
  }, []);

  const savedFilter = sessionStorage.getItem("bulkInvoiceFilterData");
  let currentFilterState: {
    filteredRows?: string[];
    filterType?: string;
    isFilterActive?: boolean;
  } = {};

  if (savedFilter) {
    try {
      currentFilterState = JSON.parse(savedFilter);
    } catch (err) {
      currentFilterState = {};
    }
  }

  // Now initialize state safely
  const [isBulkInvoiceFilterActive, setIsBulkInvoiceFilterActive] = useState<boolean>(
    currentFilterState?.isFilterActive ?? false
  );
  const [bulkInvoiceFilteredData, setBulkInvoiceFilteredData] = useState<string[]>(
    currentFilterState?.filteredRows ?? []
  );
  const [selectedBulkInvoiceFilterType, setSelectedBulkInvoiceFilterType] = useState<string>(currentFilterState?.filterType ?? "");

  useEffect(() => {
    const homePageRedirectParam = searchParams.get('redirect');
    if (homePageRedirectParam === 'bulkInvoice') {
      navigate('/dashboard/sale/bulkInvoice', { replace: true });
    }
  }, [searchParams, navigate]);

  // Utility function to clear status parameter from URL
  const clearStatusFromURL = () => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete('status');
    setSearchParams(newSearchParams);
  };

  function canWeMakeRequest() {
    if (startDate && endDate && isGapMoreThanNDays(startDate, endDate, validDateRange)) {
      setGenericModalProps(
        getGenericModalProps(
          "positive",
          `You can't select date range more than ${validDateRange} days!`
        )
      );
      setStartDate(storedStartDate)
      setEndDate(storedEndDate)
      return false;
    }
    if (
      startDate &&
      endDate &&
      isStartDateIsGreaterThanEndDate(startDate, endDate)
    ) {
      setGenericModalProps(
        getGenericModalProps(
          "positive",
          "To Date should be greater than from date."
        )
      );
      return false;
    }
    updateDatesInLocalStorage(startDate, endDate, feature, pageID);
    return true;
  }

  const handleApplyLog = async() => {
      logLoadTrace(handleApply,"manage_secondary_order_page_load_time");
  }

  const handleApply = async () => {
    if (canWeMakeRequest()) {
      storeSessionStorageDates(startDate, endDate);
      const start = getUTCDate(startDate, "start");
      const end = getUTCDate(endDate, "end");
      await getAllOrderData(start, end);
    }
  };

  const handleClearAllLog = async() => {
      logLoadTrace(handleClearAll,"manage_secondary_order_page_load_time");
  }

  const handleClearAll = async () => {
    const date = dayjs();
    storeSessionStorageDates(newStartDate, date);
    const start = getUTCDate(newStartDate, "start");
    const end = getUTCDate(date, "end");
    setStartDate(newStartDate);
    setEndDate(date);
    await getAllOrderData(start, end);
    setSelectedFilters({});
    setFilterSearchValue("");
    setStatusFilter("ALL");
    clearStatusFromURL();
    setAppliedStatusFromQuery(false);
  };

  useEffect(() => {
    localStorage.setItem('multipleFiltersListManageOrders', JSON.stringify(selectedFilters));
    
    if(multipleCategoryFilterEnabled) {
      // Check if filters were cleared and refresh data if needed
      const hasAnyFilters = Object.values(selectedFilters).some(arr => arr.length > 0);
      
      if ( !hasAnyFilters && statusFilter !== "ALL") {
        setStatusFilter("ALL");
      }
    }
  }, [selectedFilters, statusFilter]);
  

  const getAllOrderData = async (startDate: string, endDate: string) => {
    const routeIdNameMapping = routeIdNameMappingRef.current;
    const outletListResult = outletListRef.current;

    setLastRefreshed(dayjs());
    setResetSearch(true);
    setTimeout(() => setResetSearch(false), 0);
    setRows([]);
    setData([]);
    try {
      let pageNumber = 0;
      let hasMoreData = true;
      setLoader(true);
      let responseArray: manageOrderRowsData[] = [];
      const includeSkuDetailsForStatus = manageSecondaryOrderV2 ? "PENDING" : "";
      while (hasMoreData){
        const response = ConfigDictionary?.mergeManageOrderInvoice ?  await getOrderInvoiceDataWithType(
          startDate,
          endDate,
          "secondary,VisitOrder,subd",
          "",
          true,
          true,
          pageNumber,
          !(fetchLimitedOrderData.current),
          includeSkuDetailsForStatus,
        ) : await getOrderListWithType(
          startDate,
          endDate,
          "secondary,VisitOrder,subd",
          "",
          true,
          true,
          pageNumber,
          !(fetchLimitedOrderData.current)
        ) 
        

        if (response?.data?.features?.length > 0) {
          // hasMoreData = response?.data?.features?.length < 1000 ? false : true;
          response?.data?.features?.forEach((item: any, index: any) => {
            const {
              id,
              outletName,
              outletCode,
              creationTime,
              totalCaseQuantity,
              totalPieceQuantity,
              totalOtherUnitQuantity,
              netAmount,
              status,
              supplier,
              orderNumber,
              salesRepName,
              salesRepId,
              invoiceNumber,
              eInvoice,
              orderDetails,
              normalizedQuantity = 0,
            } = item || {};

            const extraParams = status === "INVOICED" ? `?type=invoice` : ``;
            const orderSource = getOrderSource(item);
            const routeId = item?.beat ?? ""
            const routeName = (ConfigDictionary.fetchPricingBySalesrep) ? (routeIdNameMapping?.[routeId]?.filter1 ?? "-") : (item?.beatName ?? "-");
            
            const allRouteNames = Object.values(routeIdNameMapping).map((route: any) => route?.filter1).filter(Boolean);
            
            const isDuplicateRouteName = allRouteNames.filter((name: string) => name === routeName).length > 1;
            
            // Show only route name by default, but if same name exists then show name-code format
            const routeIdAndName = routeId && routeName !== "-" 
              ? (isDuplicateRouteName 
                  ? `${routeName}-${routeId}`
                  : routeName)
              : "";

            const gstNo = outletListResult?.[outletCode]?.[0]?.gstNo ? "GST Outlet" : "Non-GST Outlet"
            const outletHasGstin = outletListResult?.[outletCode]?.[0]?.gstNo ? true : false

            const isCancelledInvoice: boolean =
              status?.toLowerCase() == "rejected" && invoiceNumber ? true : false;
            const downloadId = id;

            responseArray.push({
              id,
              outletName,
              supplier,
              outletCode,
              creationTime,
              totalCaseQuantity,
              totalPieceQuantity,
              totalOtherUnitQuantity,
              netAmount: netAmount,
              status: status
                ?.toLowerCase()
                ?.replace(/(?:^|\s|&)\S/g, (match: any) => match?.toUpperCase()) ?? "",
              orderNumber,
              source: orderSource,
              extraParams,
              salesRepName,
              salesRepId,
              checkOrderStatus: true,
              eInvoiced: eInvoice === "true",
              cancelledInvoice: isCancelledInvoice,
              orderDetails,
              showEyeIcon: Boolean(disableOrderEdit?.current),
              invoiceNumber,
              refNo : (invoiceNumber ? ("Invoice: " + invoiceNumber) : ("Order: " + orderNumber) ),
              routeId,
              routeName,
              routeIdAndName,
              downloadId,
              gstNo,
              outletHasGstin,
              normalizedQuantity
            });
          });

          logEvent(analytics, "secondary_order_list_viewed", {
            "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
            "total_orders_displayed": responseArray?.length,
          });
        } else {
          hasMoreData = false
          // setRows([]);
          // setData([]);
        }
        pageNumber += 1;
      }

      if(isBulkPanel.current) {
        responseArray = await stockCheckPartialRows(responseArray)
      } else {
        if (performStockCheckManageOrder.current) responseArray = await performStockCheck(responseArray)
      }

      sortByCreationTime(responseArray)
      sortBySatus(responseArray)
      // Preserve status if applied via URL param; otherwise default to ALL
      setStatusFilter((prev) => prev ?? "ALL");
      setSearchedValue("");
      setRows(responseArray);
      setData(responseArray);
      setInitialOrderData(responseArray)

      //stockQuantityExceed
    } catch (error) {
      await sendSlackAlert(
       SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
        "Order Data Fetch Error - ManageSecondaryOrder.tsx",
        `Failed to fetch order data. Error: ${(error as Error).message}`,
        safeStringify({
          userId: JSON.parse(localStorage.authContext).user.loginId,
          startDate,
          endDate,
          timestamp: new Date().toISOString(),
          error,
        })
      );
      setRows([]);
      setGenericModalProps(
        getGenericModalProps("error", "Something went wrong")
      );
    } finally {
      setLoader(false);
    }
  };


  const handleSearchValueChange = (newValue: string) => {
    setSearchedValue(newValue);
  };

  const handleStatusFilterChange = (newFilter: string) => {
    setStatusFilter(newFilter);
    
    // Only clear URL parameters if we're changing from a URL-applied filter AND going to ALL
    if (appliedStatusFromQuery && newFilter === "ALL") {
      clearStatusFromURL();
      setAppliedStatusFromQuery(false);
    }

    logEvent(analytics, "secondary_order_filter_applied", {
      "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
      "filter_type": newFilter,
    });
  };

  const handleFilterSearchValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterSearchValue(e.target.value);
    logEvent(analytics, "secondary_order_filter_applied", {
      "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
      "filter_type": e.target.value,
    });
    e.stopPropagation();
  };

  const filteredData = useMemo(() => {
    const labelToIdMap = new Map<string, string>();

    orderTrackingStagesList.forEach((stage) => {
      if (stage?.dmsLabel && stage?.id) {
        labelToIdMap.set(stage.dmsLabel.toUpperCase(), stage.id);
      }
    });

    // If user has manually changed filters and we have selectedFilters, use those
    // Otherwise fall back to statusFilter for backward compatibility
    const hasUserSelectedFilters = Object.keys(selectedFilters).length > 0 &&
      Object.values(selectedFilters).some(arr => arr.length > 0);

    let finalFilteredData;
    if (isBulkInvoiceFilterActive){
      finalFilteredData = data.filter((d: any) => bulkInvoiceFilteredData.includes(d.id)) ?? [];
    } else{
      finalFilteredData = data;
    }

    if (multipleCategoryFilterEnabled && hasUserSelectedFilters) {
      // Use multiple filter approach when user has selected specific filters
      const updatedSelectedFilters = { ...selectedFilters };

      // Convert status labels to IDs if needed
      if (filterKeys.includes("status") && selectedFilters["status"]) {
        let statuses: string[] = [];
        selectedFilters["status"].forEach((status) => {
          statuses = [...statuses, ...labelToIdMap.get(status.toUpperCase())?.split(',').map((label) => label.trim()) ?? []];
        });
        updatedSelectedFilters["status"] = statuses;
      }

      finalFilteredData = getMultipleFilterBasedData(finalFilteredData, updatedSelectedFilters, filterKeys);
    }
    // Apply search filtering
    const searchFilteredData = filterData(
      finalFilteredData,
      searchedValue?.toLowerCase(),
      searchWithStatusFilter,
      hasUserSelectedFilters ? "ALL" : statusFilter
    );

    let filteredResults = searchFilteredData;

    if (multipleCategoryFilterEnabled && hasUserSelectedFilters) {
      // Find intersection for multiple filters
      filteredResults = finalFilteredData.filter((item: any) =>
        new Set(searchFilteredData).has(item)
      );
    }

    if (searchedValue?.length !== 0) {
      logEvent(analytics, "search_secondary_order", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "search_query": searchedValue,
        "result_count": filteredResults?.length ?? 0,
      });
    }

    if (hasUserSelectedFilters) {
      logEvent(analytics, "search_secondary_order", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "filter_type": "multiple_filters_applied",
      });
    } else if (statusFilter !== "ALL") {
      logEvent(analytics, "search_secondary_order", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "filter_type": statusFilter,
      });
    }
    return filteredResults;
  }, [
    searchedValue,
    statusFilter,
    data,
    selectedFilters,
    filterKeys,
  ]);

  useEffect(() => {
    setRows(filteredData);
  }, [filteredData]);

  useEffect(() => {
    if (sortByColumn && sortByColumn.key && sortByColumn.direction !== "none") {
      const { key: sortKey, direction, type } = sortByColumn;

      const sortedRows = [...rows].sort((a: any, b: any) => {
        const valA = a[sortKey];
        const valB = b[sortKey];

        if (valA == null && valB == null) return 0;
        if (valA == null) return direction === "asc" ? -1 : 1;
        if (valB == null) return direction === "asc" ? 1 : -1;

        // 🔢 Number sort
        if (type === "number") {
          return direction === "asc"
            ? Number(valA) - Number(valB)
            : Number(valB) - Number(valA);
        }

        // 🗓️ Date sort
        if (type === "date") {
          const dateA = new Date(valA).getTime();
          const dateB = new Date(valB).getTime();

          if (isNaN(dateA) || isNaN(dateB)) {
            // fallback to string compare if parsing fails
            return direction === "asc"
              ? String(valA).localeCompare(String(valB))
              : String(valB).localeCompare(String(valA));
          }

          return direction === "asc" ? dateA - dateB : dateB - dateA;
        }

        // 🔤 String fallback
        return direction === "asc"
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      });

      setRows(sortedRows);
    }
  }, [sortByColumn]);


  useEffect(() => {
    if (appliedStatusFromQuery) return;
    // Wait until stages are available
    if (!orderTrackingStagesList || orderTrackingStagesList.length === 0) return;

    const statusParam = searchParams.get("status");

    if (statusParam) {
      const normalized = statusParam.trim().toUpperCase();
      // Try to match with stage id first, then by dms label
      const matchedById = orderTrackingStagesList.find((s) => s.id?.toUpperCase() === normalized);
      const matched = matchedById;

      if (matched && matched.id) {
        setStatusFilter(matched.id);
        // Clear previous filters and set Status multi-filter using label when available
        const statusLabel = (matched.id).toUpperCase();
        setSelectedFilters({ status: [statusLabel] });
        setAppliedStatusFromQuery(true);
        return;
      }
    }
  }, [orderTrackingStagesList, searchParams, appliedStatusFromQuery]);



  const handleSnackbarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const getInitalTableData = async () => {
    if (canWeMakeRequest()) {
      storeSessionStorageDates(startDate, endDate);
      const start = getUTCDate(startDate, "start");
      const end = getUTCDate(endDate, "end");
      await getAllOrderData(start, end);
      setBulkId(undefined);
    }
  };

  const handleDownloadAll = async () => {
    if (
      startDate &&
      endDate &&
      isStartDateIsGreaterThanEndDate(startDate, endDate)
    ) {
      setGenericModalProps(
        getGenericModalProps(
          "positive",
          "To Date should be greater than from date."
        )
      );
      return;
    }
    if (isProcessing) return;
    try{
    setIsProcessing(true);
    logEvent(analytics, "manage_order_download_all_reports_click", {
      "start_date": startDate,
      "end_date": endDate,
      "login_id": JSON.parse(localStorage.authContext).user.loginId
    });

    const startTime = window.performance.now();

    await downloadAllReportsPrimarySecondary(
      allOrdersReportIdRef.current,
      setSnackbarOpen,
      startDate,
      endDate,
      "type",
      // "VisitOrder",
      undefined,
      setIsProcessing
    );

    const endTime = window.performance.now();
    logEvent(analytics, "secondary_order_report_downloaded", {
      "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
      "report_type": "VisitOrder",
      "download_format": "xlsx",
      "download_time": (endTime - startTime),
    });
  }catch(error) {
    await sendSlackAlert(
      SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
      "Report Download Failure - ManageSecondaryOrder.tsx",
      `Failed to download all reports. Error: ${(error as Error).message}`,
      safeStringify({
        userId: JSON.parse(localStorage.authContext).user.loginId,
        startDate: startDate.format("YYYY-MM-DD"),
        endDate: endDate.format("YYYY-MM-DD"),
        timestamp: new Date().toISOString(),
        error,
      })
    );
  }
  finally{
    setIsProcessing(false);
  }
  };

  const handleCustomDownload = async (downloadId: string, setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>) => {
    if (isProcessing) return;
    
    try {
      setIsProcessing(true);
      
      const rowData = data.find(row => row?.id === downloadId);
      
      if (!rowData) {
        return;
      }
      
      let reportName = downloadSingleReportConfig?.reportId ?? "OrdersReport";
      if (ConfigDictionary?.mergeManageOrderInvoice && rowData?.invoiceNumber) {
        const salesReportIdConfig = await getConfigData(
          "dms_configuration",
          "salesReportId"
        );
        reportName = salesReportIdConfig[0]?.configValue ?? "";        
      }
      
      const customConfig = {
        reportId: reportName,
        filters: (downloadSingleReportConfig?.filters ?? []).map((filter) => {
          const filterValueKey = filter?.key ?? "";
          const filterValue = rowData?.[filterValueKey] ?? "";
          return { key: filter?.key, value: filterValue };
        }),
      };
      
      await downloadSingleReport(
        customConfig,
        setSnackbarOpen,
        setIsProcessing,
        undefined,
        false,
        undefined
      );
      
    } catch (error) {
      console.error("Download error:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const printBulkInvoices = async () => {
    setPrintInvoicesLoading(true)

    try {
      if (invoiceNumbers.length===0) return;
      const invoiceReportConfig = await getConfigData("dms_configuration", "invoiceReportId");
      
      const blobKey = 
        invoiceReportConfig[0]?.configValue[0]?.taskName === "bulkInvoiceCokeNp"
          ? await printBulkInvoicePdfCokeNp(invoiceNumbers)
          : await createAndDownloadInvoicePdf(Array.from(invoiceNumbers), false, true);

      if (!blobKey?.[0] || !ACCESS_TOKEN) {
        console.error("Invalid URL or access token.");
        setGenericModalProps(getGenericModalProps("error", "Invalid URL or access token."));
        return;
      }

      const pdfUrl = `${blobKey?.[0]}?access_token=${ACCESS_TOKEN}`;
      window.open(pdfUrl, "_blank");
      logEvent(analytics, "secondary_invoice_report_downloaded", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "invoice_id": invoiceNumbers,
        "download_format": "pdf",
      });      
      setInvoiceNumbers([]);
      setCheckedRows([]);
    } catch(e:any) {
      logEvent(analytics, "secondary_invoice_download_failed", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "invoice_id":invoiceNumbers,
        "error_reason": e.toString(),
      });
      console.error(e)
      setGenericModalProps(
        getGenericModalProps("error", "Error while fetching pdf url")
      );
    } finally {
      setPrintInvoicesLoading(false);
    }

  }

  const fetchRequiredConfigs = async () => {
    try {
      const dbResult = await getDataFromLocalDb("RouteNameIdMapping");
      routeIdNameMappingRef.current = dbResult?.data?.[0]?.data ?? {};

      const outletListResult = await getDataFromLocalDb("OutletList");
      const groupedByOutletCode = (outletListResult?.data ?? []).reduce(
        (acc: Record<string, any[]>, item: any) => {
          const code = item?.outletCode;
          if (!acc[code]) {
            acc[code] = [];
          }
          acc[code].push(item);
          return acc;
        },
        {}
      );
      outletListRef.current = groupedByOutletCode;

      const orderTrackingStages = await getConfigData(
        "order_configuration",
        "orderTrackingStages"
      );
      const orderReportIdConfig = await getConfigData(
        "dms_configuration",
        "orderReportId"
      );
      const orderSourcesConfig = await getConfigData(
        "dms_configuration",
        "orderSources"
      );
      const fetchLimitedOrderDataConfig = await getConfigData(
        "dms_configuration",
        "fetchLimitedOrderData"
      );
      const orderBulkConfirmationConfig = await getConfigData(
        "order_configuration",
        "bulkOrderConfirmation"
      );

      const manualStockAllocationConfig = await getConfigData(
        "dms_configuration",
        "isStockAllocationAllowed"
      );

      const performStockCheckManageOrderConfig = await getConfigData(
        "dms_configuration",
        "performStockCheckManageOrder"
      )

      stockAllocationAllowed.current = manualStockAllocationConfig[0]?.configValue ?? false

      const skuReplacementData = await getDataFromLocalDb("SkuReplacementData")
      skuReplacementMappingRef.current = skuReplacementData?.data?.[0]?.data ?? {};

      const productResult = await getDataFromLocalDb("Product");
      productDataRef.current = productResult?.data?.[0]?.data ?? {};

      const skuReplacementConfig = await getConfigData("dms_configuration", "enableSKUReplacement");
      setSkuReplacementConfigValue(skuReplacementConfig[0]?.configValue ?? "")
      
      const filterKeysConfig = await getConfigData("dms_configuration","multiFilterKeysManageOrders");
      setFilterKeys(filterKeysConfig[0]?.configValue ?? ["status", "salesRepName"]);
      initialFilterKeys.current = filterKeysConfig[0]?.configValue ?? ["status", "salesRepName"];
      const res12 = await getConfigData("dms_configuration", "disableOrderEditDesignationBased");
      setDisableOrderEditDesignationBased(res12[0]?.configValue?.enable ?? false);
      setOrderEditAllowedRoles(res12[0]?.configValue?.rolesAllowedForOrderEdit ?? [])
      const res9 = await getConfigData("dms_configuration", "allSecondaryOrdersReportId");
      const res8 = await getConfigData("dms_configuration", "useNewOrderStatusUpdateAPI");
      const res4 = await getConfigData("dms_configuration", "disableOrderEdit");
      const res3 = await getConfigData("dms_configuration", "disableStockCheck");
      const res10 = await getConfigData("order_configuration", "orderConfirmationEnabled")
      const res11 = await getConfigData("dms_configuration", "sequentialInvoicing")
      const orderReportId = orderReportIdConfig[0]?.configValue ?? "";
      allOrdersReportIdRef.current = res9[0] ? res9[0]?.configValue : orderReportId;
      sequentialInvoicing.current = res11[0] ? res11[0]?.configValue : sequentialInvoicing.current;
      fetchLimitedOrderData.current = fetchLimitedOrderDataConfig?.[0]?.configValue ?? false;
      singleOrderReportIdRef.current = orderReportId;
      const orderSourcesMapping: Record<string, orderSourceConfig> = {};
      orderSourcesConfig[0]?.configValue?.forEach(
        (sourceObj: orderSourceConfig) => {
          orderSourcesMapping[sourceObj.id] = sourceObj;
        }
      );
      orderSourcesRef.current = orderSourcesMapping;
      disableStockCheck.current = res3[0]?.configValue?.toLowerCase?.() === "true" ? true : false;
      useNewOrderStatusUpdateAPI.current = res8[0]?.configValue ?? false;
      isBulkOrderConfirmAllowed.current = orderBulkConfirmationConfig[0]?.configValue === "true";
      orderConfirmationEnabled.current = res10[0]?.configValue ?? true;
      setOrderTrackingStagesList(orderTrackingStages[0]?.configValue ?? []);
      setDownloadSingleReportConfig(
        getDownloadSingleReportConfig(orderReportId)
      );
      disableOrderEdit.current = res4[0]?.configValue ?? false;
      performStockCheckManageOrder.current = performStockCheckManageOrderConfig[0]?.configValue ?? true

    } catch (e) {
      await sendSlackAlert(
        SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
        "Configuration Fetch Error - ManageSecondaryOrder.tsx",
        `Failed to fetch required configurations. Error: ${(e as Error).message}`,
        safeStringify({
          userId: JSON.parse(localStorage.authContext).user.loginId,
          timestamp: new Date().toISOString(),
          e,
        })
      );
      console.error("Error while fetching configs", e);
    }
  };

  const initInitialize = async () => {
    await fetchRequiredConfigs();
    await getInitalTableData();
  }

  useEffect(() => {
    const interval = setInterval(() => {
      getInitalTableData();
    }, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [startDate, endDate]);

  const init = async () => {
    setLoader(true);
    // Wait for all promises to resolve successfully
    await initInitialize();
  };

  useEffect(() => {
    if (!viewBulkConfirm) {
      logLoadTrace(init,"manage_secondary_order_page_load_time");
    }
  }, [viewBulkConfirm, startDate, endDate]);

  useEffect(() => {
    const counts: Record<string, Record<string, number>> = {};
    filterKeys.forEach((key) => {
      counts[key] = {};
    });

    if (filterKeys.includes("status")) {
      const labelToIdMap = new Map<string, string>();
      let allDmsLabel: string | undefined;
      orderTrackingStagesList.forEach((stage) => {
        if (stage?.dmsLabel && stage?.id) {
          labelToIdMap.set(stage.dmsLabel.toUpperCase(), stage.id);
          if (stage.id === "ALL") {
            allDmsLabel = stage.dmsLabel.toUpperCase();
          }
        }
      });

      orderTrackingStagesList.forEach((stage: any) => {
        if (stage?.dmsLabel && stage.dmsLabel.toUpperCase() !== allDmsLabel) {
          counts["status"][stage.dmsLabel.toUpperCase()] = 0;
        }
      });

      data.forEach((row: any) => {
        const rowStatus = row?.status?.toUpperCase();
        Object.keys(counts["status"]).forEach((key) => {
          const labels = labelToIdMap.get(key)?.split(',').map((label) => label.trim()) ?? [];
          if (labels.includes(rowStatus)) {
            counts["status"][key] += 1;
          }
        });
      });
    }

    filterKeys.filter((key) => key !== "status").forEach((key) => {
      data.forEach((row: any) => {
        const value = row[key];
        if ( typeof value === "string" && value) {
          counts[key][value.toLowerCase()] = (counts[key][value.toLowerCase()] || 0) + 1;
        }
      });
    });

    setMultipleFiltersList(counts);
  }, [orderTrackingStagesList, data, filterKeys]);

  useEffect(() => {
    if (isBulkInvoiceFilterActive){
      setFilterKeys((prev) => prev.filter((p) => p !== "status"));
    } else{
      setFilterKeys(initialFilterKeys.current)
    }
  }, [isBulkInvoiceFilterActive])

  const handleBulkNav = (pendingOrders: any[]) => {
    const arePendingOrdersPresent = Array.isArray(rows) &&
            rows.some((r) => r.status.toLowerCase() === "pending")
    if (!arePendingOrdersPresent) return
    if (orderConfirmationEnabled.current) {
      setViewBulkConfirm(!viewBulkConfirm)
    } else {
      navigate("/dashboard/sale/bulkInvoice", {
        state: { selectedPendingOrder: pendingOrders },
      });
    }
  }
  const resetGenericModalProps = () => setGenericModalProps(initialGenericModalProps);
  const [orderBulkStatusMap, setOrderBulkStatusMap] = useState<BulkOrderMapType>(orderStatusMap);
  const [bulkId, setBulkId] = useState<string | undefined>(undefined);
  const [isBulkStillProcessing, setIsBulkStillProcessing] = useState<boolean>(true);
  const [showProgress, setShowProgress] = useState<any>(
    showProgressInitialState
  );
  const [invoicableOrders, setInvoicableOrders] = useState<manageOrderRowsData[]>([]);
  const [partiallyInvoicableOrders, setPartiallyInvoicableOrders] = useState<manageOrderRowsData[]>([]);
  const [unavailableOrders, setUnavailableOrders] = useState<manageOrderRowsData[]>([]);
  const [bulkInvoiceButtonLoading,setBulkInvoiceButtonLoading] = useState<boolean>(false)
  const [bulkInvoiceStatusMap, setBulkInvoiceStatusMap] =
    useState<BulkStatus>(initialBulkStatusMap);

  const handleUpdateBulkStatus = async (bulkId: string | undefined) => {
    const { newOrderStatusMap, orderInvoiceNumberMap } = await getBulkOpertionData(bulkId);
    console.log("newOrderStatusMap", newOrderStatusMap)
    let isStillInProgress = newOrderStatusMap?.inProgress?.length > 0;
    let confirmed: string[] = newOrderStatusMap?.confirmed || [];
    let partialConfirmed: string[] = newOrderStatusMap?.partiallyConfirmed || [];
    let rejected: string[] = newOrderStatusMap?.rejected || [];
    let invoice: string[] = newOrderStatusMap?.invoiced || [];
    let partiallyInvoiced: string[] = newOrderStatusMap?.partiallyInvoiced || [];
    let failed: string[] = newOrderStatusMap?.failed || [];

    let dataOrderNumbers: string[] = [];
    for (const ro of data) {
      let roON = ro?.orderNumber;
      dataOrderNumbers.push(roON);
    }

    // Filter each status array to only include order numbers present in dataOrderNumbers
    newOrderStatusMap.inProgress = (newOrderStatusMap?.inProgress || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.confirmed = (newOrderStatusMap?.confirmed || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.partiallyConfirmed = (newOrderStatusMap?.partiallyConfirmed || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.rejected = (newOrderStatusMap?.rejected || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.invoiced = (newOrderStatusMap?.invoiced || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.partiallyInvoiced = (newOrderStatusMap?.partiallyInvoiced || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.failed = (newOrderStatusMap?.failed || []).filter(orderNum => dataOrderNumbers.includes(orderNum));

    const excluded = new Set([
      ...confirmed,
      ...partialConfirmed,
      ...rejected,
      ...invoice,
      ...partiallyInvoiced,
      ]);

    // Filter `pre` to remove excluded items
    const filtered = pendingOrderNumbers.filter(orderNumber => !excluded.has(orderNumber));

    // Set the new state
    setPendingOrderNumbers(filtered);
    setOrderBulkStatusMap(newOrderStatusMap);
    setIsBulkStillProcessing(isStillInProgress);
    setInvoiceNumbers([...invoiceNumbers, ...Array.from(orderInvoiceNumberMap.values())])

    if(orderInvoiceNumberMap.size !== 0) {
      setRows((prevRows: manageOrderRowsData[]) =>
        prevRows.map((row: manageOrderRowsData) => {
          const newInvoiceNumber = orderInvoiceNumberMap.get(row.orderNumber);
          if (newInvoiceNumber !== undefined) {
            return {
              ...row,
              invoiceNumber: newInvoiceNumber || "",
            };
          }
          return row;
        })
      );
    }

    if(isBulkStillProcessing && !isStillInProgress) {
      setTimeout(() => {
        setShowProgress(showProgressInitialState);
      }, 5000);
    }
  }

  useEffect(() => {
    const { pass, partial, fail, pending, rejected, invoiced, partiallyInvoiced } = bulkInvoiceStatusMap;

    const updatedRows: manageOrderRowsData[] = [...rows]?.map(
      (row: manageOrderRowsData) => {
        const invoiceNumber = row?.invoiceNumber
        const orderNumber = row?.orderNumber;
        const status = determineBulkStatus(
          orderNumber,
          pass,
          partial,
          fail,
          pending,
          rejected,
          invoiced,
          row,
          partiallyInvoiced,
        );
        return { ...row, status, invoiceNumber };
      }
    );
    setRows(updatedRows);

    const updatedInitialOrderData: manageOrderRowsData[] = [...initialOrderData]?.map(
      (row: manageOrderRowsData) => {
        const invoiceNumber = row?.invoiceNumber
        const orderNumber = row?.orderNumber;
        const status = determineBulkStatus(
          orderNumber,
          pass,
          partial,
          fail,
          pending,
          rejected,
          invoiced,
          row,
          partiallyInvoiced,
        );
        return { ...row, status, invoiceNumber };
      }
    )
    setInitialOrderData(updatedInitialOrderData)
    const total: number =
      (bulkInvoiceStatusMap?.fail?.length ?? 0) +
      (bulkInvoiceStatusMap?.pass?.length ?? 0) +
      (bulkInvoiceStatusMap?.rejected?.length ?? 0) +
      (bulkInvoiceStatusMap?.invoiced?.length ?? 0) +
      (bulkInvoiceStatusMap?.pending?.length ?? 0) + (bulkInvoiceStatusMap?.partial?.length ?? 0) +
      (bulkInvoiceStatusMap?.partiallyInvoiced?.length ?? 0);
    if(total > 0) {
      setShowProgress({ progress: true, fail: true });
    }
  }, [bulkInvoiceStatusMap]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if(isBulkStillProcessing && (useKafkaBulkFlow && useKafkaBulkFlow)) {
        handleUpdateBulkStatus(bulkId);
      }
    }, 1000);

    // Cleanup to avoid memory leaks
    return () => clearInterval(intervalId);
  }, [isBulkStillProcessing, bulkId]);

  const bulkInvoceInProgress = Boolean(bulkInvoiceStatusMap?.pending?.length);


  const handleBulkInvoicingNewApproach = async (pendingOrderNumbers: string[]) => {
    try {
      let selectedOrders: manageOrderRowsData[] = [];
      for (const ro of data) {
        const orderNumber = ro.orderNumber;
        // NOTE: only use selected rows
        if (!pendingOrderNumbers.includes(orderNumber)) continue;
        selectedOrders.push(ro);
      }
      let confirmableOrderNumbers: string[] = (selectedOrders)?.flatMap(s => s?.orderNumber) ?? [];

      const res = await generateBulkInvoice(confirmableOrderNumbers);
      const newOrderStatusMap: BulkOrderMapType = {
        inProgress: [],
        confirmed: [],
        partiallyConfirmed: [],
        rejected: [],
        failed: [],
        invoiced: [],
        partiallyInvoiced: [],
      };
      newOrderStatusMap.inProgress.push(...confirmableOrderNumbers);

      if (res.status === 208) {
        setOrderBulkStatusMap(orderStatusMap);
        setBulkId(undefined);
        setIsBulkStillProcessing(true);
      } else if(res && res?.data?.bulkId){
        setOrderBulkStatusMap(newOrderStatusMap);
        let bulkId = res?.data?.bulkId;
        setBulkId(bulkId);
        setIsBulkStillProcessing(true);
      }
    } catch (error) {
      console.error("Error during bulk invoicing: ", error);
      setGenericModalProps(
        getGenericModalProps("error", "An error occurred while processing bulk invoicing. Please try again.")
      );
    }
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for Ctrl+A or Command+A
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'a') {
        event.preventDefault(); // Prevent default browser behavior (e.g., select all)
        // Only trigger if bulk order confirmation is allowed and no modal is open
        if (!document.querySelector('[role="dialog"]')) {
          logLoadTrace(
            () =>  !orderConfirmationEnabled.current ?  handleBulkInvoiceClick(pendingOrderDataForBulkButton) : setViewBulkConfirm(true),
            "manage_secondary_order_bulk_confirm_toggle_time"
          );
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [viewBulkConfirm, pendingOrderDataForBulkButton]);

  useEffect(() => {
    if (!isBulkStillProcessing){
      setCheckedRows([])
    }
  }, [isBulkStillProcessing])

  const handleBulkInvoicing = async (pendingOrderNumbers: string[]) => {
    try {

      if (!pendingOrderNumbers || pendingOrderNumbers.length === 0) {
        setGenericModalProps(
          getGenericModalProps("positive", "Please select at least one order to create invoices.")
        );
        return;
      }

      // Start a custom trace for manage secondary order bulk confirmation load time
      const pageLoadTrace: PerformanceTrace = trace(performance, "bulk_invoice_handle_invoicing_load_time");
      pageLoadTrace.start();

      setShowProgress({ progress: true, fail: true });

      setBulkInvoiceStatusMap({
        ...initialBulkStatusMap,
        pending: pendingOrderNumbers,
      });

      let total_orders_confirmed = 0;
      let total_orders_rejected = 0;
      
      // Process in batches of 30
      setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
        ...prev,
        inProgress: pendingOrderNumbers,
      }));
      const batchSize = 30;
      for (let i = 0; i < pendingOrderNumbers.length; i += batchSize) {
        const batch = pendingOrderNumbers.slice(i, i + batchSize);
        console.log(`Processing batch ${i/batchSize + 1}: ${batch.length} orders`);
        
        let sequential: boolean = (sequentialInvoicing.current && useKafkaBulkFlow && batch?.length <= 5);

        // Extract the core logic into a helper so we can reuse it
        const processOrder = async (orderNumber: string) => {
          try {
            const discountPayload = {
              orderNumber,
              discountType: "value",
              discountValue: 0,
            };
            const response = await createInvoice(discountPayload);

            if ((response?.status === 200 || response?.status === 201) && response?.data?.status === "INVOICED") {
              setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
                ...prev,
                invoiced: [...prev.invoiced, orderNumber],
                inProgress: prev.inProgress.filter(order => order !== orderNumber),
              }));

              setRows((prevRows: manageOrderRowsData[]) =>
                prevRows.map((row: manageOrderRowsData) => {
                  if (row.orderNumber === orderNumber) {
                    return {
                      ...row,
                      invoiceNumber: response?.data?.invoiceNumber || "",
                    };
                  }
                  return row;
                })
              );

              // automatically queue invoice numbers for download
              setInvoiceNumbers((prev: string[]) => [...prev, response?.data?.invoiceNumber]);

              return { success: true, orderNumber };
            } else if ((response?.status === 200 || response?.status === 201) && response?.data?.status === "REJECTED") {
              setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
                ...prev,
                rejected: [...prev.rejected, orderNumber],
                inProgress: prev.inProgress.filter(order => order !== orderNumber),
              }));
              return { success: true, orderNumber };
            } else if (response?.data?.status === "PARTIALLY INVOICED") {
              setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
                ...prev,
                partiallyInvoiced: [...(prev?.partiallyInvoiced ?? []), orderNumber],
                inProgress: prev.inProgress.filter(order => order !== orderNumber),
              }));

              setRows((prevRows: manageOrderRowsData[]) =>
                prevRows.map((row: manageOrderRowsData) => {
                  if (row.orderNumber === orderNumber) {
                    return {
                      ...row,
                      invoiceNumber: response?.data?.invoiceNumber || "",
                    };
                  }
                  return row;
                })
              );

              setInvoiceNumbers((prev: string[]) => [...prev, response?.data?.invoiceNumber || ""]);
              return { success: true, orderNumber };
            } else {
              throw new Error("Failed to create invoice");
            }
          } catch (error) {
            console.error(`Error processing order ${orderNumber}:`, error);
            setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
              ...prev,
              failed: [...prev.failed, orderNumber],
              inProgress: prev.inProgress.filter(order => order !== orderNumber),
            }));
            return { success: false, orderNumber };
          }
        };

        // --- Parallel vs Sequential toggle ---
        let batchResults;

        if (sequential) {
          // 🕒 Sequential execution
          batchResults = [];
          for (const orderNumber of batch) {
            const result = await processOrder(orderNumber);
            batchResults.push({ status: "fulfilled", value: result });
          }
        } else {
          // ⚡ Parallel execution (current behavior)
          batchResults = await Promise.allSettled(batch.map(processOrder));
        }

        // Count successful and failed orders in this batch
        batchResults.forEach(result => {
          if (result.status === 'fulfilled') {
            const value = result.value;
            if (value.success) {
              total_orders_confirmed++;
            } else {
              total_orders_rejected++;
            }
          } else {
            total_orders_rejected++;
          }
        });
      }

      logEvent(analytics, "secondary_order_bulk_invoiced", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "total_orders_confirmed": total_orders_confirmed,
      });
      logEvent(analytics, "secondary_order_bulk_rejected", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "total_orders_rejected": total_orders_rejected,
      });

      // Once data is fetched and state is updated, stop the trace
      pageLoadTrace.stop();

    } catch (error) {
      console.error("Error during bulk invoicing: ", error);
      setGenericModalProps(
        getGenericModalProps("error", "An error occurred while processing bulk invoicing. Please try again.")
      );
    } finally {
      setPendingOrderNumbers([]);
      setPendingOrderDataForBulkButton([])
      setCheckedRows([])
      setTimeout(() => {
        setShowProgress(showProgressInitialState);
      }, 5000);
    }
  };
  const skuReplacementMappingRef = useRef<any>({});
  const productDataRef = useRef<any>({})

  
  function createReplacementMap(
    skuReplacementData: { entityId: string; parentId: string }[]
  ): Map<string, string[]> {
    const replacementMap = new Map<string, string[]>();
  
    skuReplacementData.forEach(({ entityId, parentId }) => {
      if (!replacementMap.has(entityId)) {
        replacementMap.set(entityId, []);
      }
  
      const arr = replacementMap.get(entityId)!;
  
      if (!arr.includes(parentId)) {
        arr.push(parentId);
      }
    });
  
    return replacementMap;
  }
  const createSkuBatchMap = (
    batchNodes: any[],
    productData: Record<string, any>
  ) => {
    const finalSkuBatchMap = new Map<
      string,
      { latestExpiryDate: string; totalNq: number }
    >();
  
    batchNodes.forEach((node: any) => {
      const productInfo = productData[node?.skuCode] ?? {};
      const caseToPiece = productInfo?.caseToPieceQuantity ?? 0;
      const otherUnitToPiece = productInfo?.otherUnitToPieceQuantity ?? 0;
  
      let nq = 0;
      switch (node.quantityType) {
        case "caseQty":
          nq = Number(node.availableQty ?? 0) * caseToPiece;
          break;
        case "otherQty":
          nq = Number(node.availableQty ?? 0) * otherUnitToPiece;
          break;
        case "pieceQty":
          nq = Number(node.availableQty ?? 0);
          break;
        default:
          nq = 0;
      }
  
      const existing = finalSkuBatchMap.get(node.skuCode);
      if (existing) {
        // sum up nq
        existing.totalNq += nq;
  
        // keep the latest (maximum) expiry date
        if (new Date(node.expiryDate).getTime() > new Date(existing.latestExpiryDate).getTime()) {
          existing.latestExpiryDate = node.expiryDate;
        }
      } else {
        finalSkuBatchMap.set(node.skuCode, {
          latestExpiryDate: node.expiryDate,
          totalNq: nq,
        });
      }
    });
  
    return finalSkuBatchMap;
  };

  function deductStockFromOrders(
    stockMap: Map<string, { latestExpiryDate: string; totalNq: number }>,
    checkedOrderDetailsMap: Map<string, { batchCode: string; nq: number }[]>
  ) {
    checkedOrderDetailsMap.forEach((skuList, orderNumber) => {
      const updatedSkuList = skuList.map((sku) => {
        const stockEntry = stockMap.get(sku.batchCode);
  
        if (!stockEntry) return sku; // no stock entry, leave as is
  
        const availableStock = stockEntry.totalNq;
  
        // Deduct without going negative
        const deductedQty = Math.min(availableStock, sku.nq);
        stockEntry.totalNq = Math.max(availableStock - deductedQty, 0);
  
        return {
          ...sku,
          nq: Math.max(sku.nq - deductedQty, 0),
        };
      });
  
      // Update map with remaining SKUs
      checkedOrderDetailsMap.set(orderNumber, updatedSkuList);
    });
  }

    function calculateOrderInvoiceStatus(
    checkedOrderDetailsMap: Map<string, { batchCode: string; nq: number }[]>,
    originalCheckedOrderDetailsMap: Map<string, { batchCode: string; nq: number }[]>
  ) {
    let fullyInvoiced: string[] = [];
    let partialInvoiced: string[] = [];
    let failed: string[] = [];
  
    checkedOrderDetailsMap.forEach(
      (updatedSkuList: { batchCode: string; nq: number }[], orderNumber: string) => {
        const originalSkuList = originalCheckedOrderDetailsMap.get(orderNumber);
        if (!originalSkuList) return;
  
        let allNqZero = true;
        let allNqSame = true;
  
        updatedSkuList.forEach((updatedSku: { batchCode: string; nq: number }, index: number) => {
          const originalSku = originalSkuList[index];
          if (!originalSku) return;
  
          if (updatedSku.nq !== 0) {
            allNqZero = false;
          }
  
          if (updatedSku.nq !== originalSku.nq) {
            allNqSame = false;
          }
        });
  
        if (allNqSame) {
          failed = [...failed, orderNumber];
        } else if (allNqZero) {
          fullyInvoiced = [...fullyInvoiced, orderNumber];
        } else {
          partialInvoiced = [...partialInvoiced, orderNumber];
        }
      }
    );
  
    return { fullyInvoiced, partialInvoiced, failed };
  }

  const fetchBulkInvoiceSummary = async (pendingOrders: manageOrderRowsData[]) => {
    let fullyInvoiced: string[] = [];
    let partialInvoiced: string[] = [];
    let failed: string[] = [];

    try {
      setBulkInvoiceButtonLoading(true);

      // fetch batchwise stock data from API
      const batchWiseStock = await fetchBatchWiseStock();
      
      // fetch sku replacement data from local DB
      const skuReplacementData = skuReplacementMappingRef.current;
      
      // map SKU to its list of replacement skus A->[B,C,D]
      const replacementSkuMap = createReplacementMap(skuReplacementData);

      // order data
      const orderData = data;
      
      // product data
      const productData = productDataRef.current ?? {};

      // map of order and list of SKU having batchCode and nq
      const checkedOrderDetailsMap = new Map();

      (pendingOrders.map((order) => order?.orderNumber)).forEach((orderNumber) => {
        const orderD = orderData.find((order: any) => order?.orderNumber === orderNumber);
        if (!orderD) return;

        // Only keep batchCode and nq
        const reducedOrderDetails = (orderD?.orderDetails ?? [])
          .filter((detail: any) => detail.type !== "free")
          .map((detail: any) => {
            const productInfo = productData[detail.batchCode] ?? {};
            const caseToPieceQuantity = productInfo?.caseToPieceQuantity ?? 0;
            const otherUnitToPieceQuantity = productInfo?.otherUnitToPieceQuantity ?? 0;

            const nq =
              (Number(detail.caseQuantity ?? 0) * caseToPieceQuantity) +
              (Number(detail.otherUnitQuantity ?? 0) * otherUnitToPieceQuantity) +
              Number(detail.pieceQuantity ?? 0);

            return { batchCode: detail.batchCode, nq };
          });

        checkedOrderDetailsMap.set(orderNumber, reducedOrderDetails);
      });

      const originalCheckedOrderDetailsMap = new Map(
        Array.from(checkedOrderDetailsMap.entries()).map(([orderNumber, skuList]: any) => [
          orderNumber,
          skuList.map((sku: any) => ({ ...sku })),
        ])
      );

      // final stock data: batch code mapped to latest expiry and totalNq
      const skuMapTotalNqLatestExpiry = createSkuBatchMap(batchWiseStock, productData);

      // deduct stock from checkedOrderDetailsMap based on available stock
      deductStockFromOrders(skuMapTotalNqLatestExpiry, checkedOrderDetailsMap);

        // SKU replacement is enabled
        checkedOrderDetailsMap.forEach((skuList, orderNumber) => {
          skuList.forEach((sku: any) => {
            if (sku.nq <= 0) return; // Already fulfilled

            // Deduct from original SKU
            const originalStock = skuMapTotalNqLatestExpiry.get(sku.batchCode);
            if (originalStock) {
              const deductQty = Math.min(sku.nq, originalStock.totalNq);
              sku.nq -= deductQty;
              originalStock.totalNq -= deductQty;
            }

            // Deduct from replacement SKUs if still remaining
            if (sku.nq > 0) {
              const replacements = replacementSkuMap.get(sku.batchCode) ?? [];

              replacements.sort((a, b) => {
                const stockA = skuMapTotalNqLatestExpiry.get(a)?.latestExpiryDate ?? '';
                const stockB = skuMapTotalNqLatestExpiry.get(b)?.latestExpiryDate ?? '';
                return new Date(stockB).getTime() - new Date(stockA).getTime();
              });

              replacements.forEach((replacementBatch) => {
                if (sku.nq <= 0) return;
                const replacementStock = skuMapTotalNqLatestExpiry.get(replacementBatch);
                if (!replacementStock || replacementStock.totalNq <= 0) return;

                const deductQty = Math.min(sku.nq, replacementStock.totalNq);
                sku.nq -= deductQty;
                replacementStock.totalNq -= deductQty;
              });
            }
          });

          // Update order map
          checkedOrderDetailsMap.set(orderNumber, skuList);
        });

        // Recalculate invoice status after using replacements
        ({ fullyInvoiced, partialInvoiced, failed } = calculateOrderInvoiceStatus(
          checkedOrderDetailsMap,
          originalCheckedOrderDetailsMap
        ));
      
      return { fullyInvoiced, partialInvoiced, failed };

    } catch (err) {
      console.error("Error fetching bulk invoice summary:", err);
      return { fullyInvoiced: [], partialInvoiced: [], failed: [] };
    } finally {
      setBulkInvoiceButtonLoading(false);
    }
  };
      
  const handleBulkInvoiceClick = async (pendingOrders: manageOrderRowsData[]) => {
      let confOrdersSize: number;
      let parOrdersSize: number;
      let canOrdersSize: number;
    if (!pendingOrders || pendingOrders.length === 0) {
      setGenericModalProps(
        getGenericModalProps("positive", "Please select at least one order to create invoices.")
      );
      return;
    }
    try{
      setBulkInvoiceButtonLoading(true)

      const result = ConfigDictionary.useStockValidate ? await calculateBulkInvoiceSummaryUsingStockValidate(pendingOrders) :  await performStockCheckForBulkInvoicing(pendingOrders);

      if (result === null) {
        setInvoicableOrders([]);
        setPartiallyInvoicableOrders([]);
        setUnavailableOrders([]);
        return;
      } else {
        const {confOrders, parOrders, canOrders} = result;
        setInvoicableOrders(confOrders);
        setPartiallyInvoicableOrders(parOrders);
        setUnavailableOrders(canOrders);
        confOrdersSize = confOrders.length;
        parOrdersSize = parOrders.length;
        canOrdersSize = canOrders.length;
      }
    } catch (error){
      console.log(error);
      return;
    } finally{
      setBulkInvoiceButtonLoading(false)
    }

    const tempPendingOrderNumbers = pendingOrders.map(order => order.orderNumber)
    
    if(orderConfirmationEnabled.current || disableStockCheck.current) {
      (useKafkaBulkFlow && useKafkaBulkFlow && pendingOrders?.length > 5) ? handleBulkInvoicingNewApproach(tempPendingOrderNumbers) : handleBulkInvoicing(tempPendingOrderNumbers)
      return;
    }

    if(ConfigDictionary.useStockValidate) {
      // Update the summary counts
      setSummaryInvoicableCount(confOrdersSize);
      setSummaryPartiallyInvoicableCount(parOrdersSize);
      setSummaryUnavailableCount(canOrdersSize);
    } else if(skuReplacementConfigValue && !ConfigDictionary.useStockValidate) {

      const bulkInvoiceSummaryResult = await fetchBulkInvoiceSummary(pendingOrders);
      const { fullyInvoiced, partialInvoiced, failed } = bulkInvoiceSummaryResult;

      // Update the summary counts
      setSummaryInvoicableCount(fullyInvoiced?.length ?? 0);
      setSummaryPartiallyInvoicableCount(partialInvoiced?.length ?? 0);
      setSummaryUnavailableCount(failed?.length ?? 0);

      setInvoicableOrders(rows?.filter((s: manageOrderRowsData) => fullyInvoiced?.includes(s?.orderNumber)));
      setPartiallyInvoicableOrders(rows?.filter((s: manageOrderRowsData) => partialInvoiced?.includes(s?.orderNumber)));
      setUnavailableOrders(rows?.filter((s: manageOrderRowsData) => failed?.includes(s?.orderNumber)));
    }
    
    const updatedGenericModalProps = getGenericModalProps(
      "positive",
      "Review the Bulk Invoicing of the selected Orders:",
      "Continue",
      `${stockAllocationAllowed.current ? "Review & Adjust" : "Cancel"}`,
      () => {
        (useKafkaBulkFlow && useKafkaBulkFlow && pendingOrders?.length > 5) ? handleBulkInvoicingNewApproach(tempPendingOrderNumbers) : handleBulkInvoicing(tempPendingOrderNumbers)
        resetGenericModalProps()
      },
      () => {
        if (stockAllocationAllowed.current){
          handleStockAllocation(pendingOrders)
        } else{
          resetGenericModalProps()
        }
      }
    );
    setGenericModalProps(updatedGenericModalProps);
  }

  useEffect(() => {
    const updateProgressbar = () => {
      let pending: string[] = [];
      let rejected: string[] = [];
      let failed: string[] = [];
      let confirmed: string[] = [];
      let partiallyConfirmed: string[] = [];
      let invoiced: string[] = [];
      let partiallyInvoiced: string[] = [];

      for (const ro of data) {
        let orderNumber: string = ro?.orderNumber;
        if (orderBulkStatusMap.inProgress.includes(orderNumber)) {
          pending.push(orderNumber);
        } else if (orderBulkStatusMap.rejected.includes(orderNumber)) {
          rejected.push(orderNumber);
        } else if (orderBulkStatusMap.failed.includes(orderNumber)) {
          failed.push(orderNumber);
        } else if (orderBulkStatusMap.confirmed.includes(orderNumber)) {
          confirmed.push(orderNumber);
        } else if(orderBulkStatusMap.invoiced.includes(orderNumber)){
          invoiced.push(orderNumber)
        } else if (orderBulkStatusMap.partiallyConfirmed.includes(orderNumber)) {
          partiallyConfirmed.push(orderNumber);
        } else if ((orderBulkStatusMap?.partiallyInvoiced ?? []).includes(orderNumber)) {
          partiallyInvoiced.push(orderNumber);
        }
      }
      if(pending.length + rejected.length + failed.length + confirmed.length + partiallyConfirmed.length + invoiced.length + partiallyInvoiced.length > 0) {
        setBulkInvoiceStatusMap((prev: BulkStatus) => ({
          ...prev,
          pending: [...pending],
          invoiced: [...prev.invoiced, ...invoiced],
          partiallyInvoiced: [...(prev?.partiallyInvoiced ?? []), ...partiallyInvoiced],
          rejected: [...prev.rejected, ...rejected],
          fail: [...prev.fail, ...failed],
        }));
      }
    }
    updateProgressbar();
  }, [orderBulkStatusMap])

  function handleSortByStock() {
    setRows(() => [...initialOrderData].sort((a, b) => {
      const aExceed = !!a.stockQuantityExceed;
      const bExceed = !!b.stockQuantityExceed;

      if (aExceed && !bExceed) return -1;
      if (!aExceed && bExceed) return 1;
      return 0;
    })
    );
  }


  const handleRedirect = async(url: string, rowData: any) => {
   
    let targetPath: string;
  
    if (ConfigDictionary?.mergeManageOrderInvoice && rowData?.invoiceNumber) {
      targetPath = `/dashboard/sale/manageInvoices/viewInvoice/${rowData.orderNumber}`;
    } else {
      targetPath = `/dashboard/sale/manageOrders/viewOrder/${rowData.id}`;
    }
    let aggregateStockSummaryMap = await aggregateStockSummary(stockValidateResponse, sortedPendingOrderNumbers, rowData.orderNumber);
    let isPartialOrder: boolean = false;
    if(isBulkInvoiceFilterActive && isBulkPanel.current && !disableStockCheck.current) {
      let bulkSummary = ConfigDictionary.useStockValidate ? await calculateBulkInvoiceSummaryUsingStockValidate(rows, stockValidateResponse) : await performStockCheckForBulkInvoicing(rows?.filter(r => "PENDING" === r?.status?.toUpperCase()));
      let orderNumberList = bulkSummary?.parOrders.flatMap(od => od?.orderNumber) ?? [];
      isPartialOrder = orderNumberList.includes(rowData?.orderNumber);
      navigate(targetPath, {
        state: {
          rowData,
          aggregateStockSummaryMap,
          isPartialOrder,
          isBulkPanel: isBulkPanel.current
        }
      });
    } else {
      navigate(targetPath, {
        state: {
          rowData,
          isPartialOrder
        }
      });
    }
  };
  

  const handleSelectedFilterChange = (key: string, value: string) => {
    setSelectedFilters((prev) => {
      const current = prev[key] || [];
      const newFilters = {
        ...prev,
        [key]: current.includes(value)
          ? current.filter((v) => v !== value)
          : [...current, value],
      };
      
      // Check if this was the last filter being deselected
      const hasAnyFilters = Object.values(newFilters).some(arr => arr.length > 0);
      
      if (!hasAnyFilters) {
        // Use setTimeout to avoid state update conflicts
        setTimeout(() => {
          clearStatusFromURL();
          setAppliedStatusFromQuery(false);
          setStatusFilter("ALL");
        }, 0);
      }
      
      return newFilters;
    });
  };

  const handleFilterTypeChange = (type: string) => {
    setSelectedFilterType(type);
    setFilterSearchValue("");
  };

  useEffect(() => {
    if (!checkedRows?.length) {
      setInvoiceNumbers([]);
      setPendingOrderNumbers([]);
      return;
    }

    const validInvoiceStatuses = [
      "invoiced",
      "partially invoiced",
      "out for delivery",
      "delivered",
    ];

    const selectedRows = rows.filter(row => checkedRows.includes(row.id));
    const invoices = selectedRows
      .filter(row => {
        const status = row.status?.toLowerCase();
        return status && validInvoiceStatuses.includes(status);
      })
      .map(row => row.invoiceNumber)
      .filter((num): num is string => Boolean(num));

    const pendings = selectedRows.filter(
      row => row.status?.toLowerCase() === "pending"
    );

    setInvoiceNumbers(invoices);
    setPendingOrderNumbers(pendings.map(row => row.orderNumber));
    setPendingOrderDataForBulkButton(pendings);
  }, [checkedRows, rows]);

  const calculateOrderCount = () => {
    let pendingCount = 0
    let invoicedCount = 0
    let pendingAmount = 0
    let invoicedAmount = 0
    initialOrderData.forEach((item) => {
      if (item?.status?.toUpperCase() === "PENDING") {
        pendingCount += 1 
        pendingAmount += parseFloat(item.netAmount)
      }
      if (item?.status?.toUpperCase() === "INVOICED" || item?.status?.toUpperCase() === "PARTIALLY INVOICED") {
        invoicedCount += 1
        invoicedAmount += parseFloat(item.netAmount)
      }
    })
    itemObjects.current = [
      {
        itemLabel: "Total Pending Orders",
        itemValue1: `${pendingCount}`,
        itemValue2: formatAmount(pendingAmount, currencySymbol),
        svgIcon: "pendingOrdersSVG",
        itemStyles: {
          itemValue1: {
            fontWeight: "bold"
          },
          itemValue2: {
            color: "#CC8034",
            backgroundColor: "#FFFBE7"
          }
        }
      },
      {
        itemLabel: "Total Invoiced Orders",
        itemValue1: `${invoicedCount}`,
        itemValue2: formatAmount(invoicedAmount, currencySymbol),
        svgIcon: "invoicedOrdersSVG",
        itemStyles: {
          itemValue1: {
            fontWeight: "bold"
          },
          itemValue2: {
            color: "#5A865A",
            backgroundColor: "#EAFFEA"
          }
        }
      },
    ];
  }
  const reset = () => {
    setOrderBulkStatusMap(orderStatusMap);
    setLoader(false);
    setCheckedRows([]);
    setBulkInvoiceStatusMap(initialBulkStatusMap);
    setShowProgress(showProgressInitialState);
    setInvoiceNumbers([])
    setGenericModalProps(initialGenericModalProps)
    setPrintInvoicesLoading(false)
    setResetSearch(true); 
    setTimeout(() => setResetSearch(false), 0);
  };

  const filterOrders = (rowsData: manageOrderRowsData[]): void => {
    sortByCreationTime(rowsData)
    sortBySatus(rowsData)
    setRows(rowsData);
    reset()
  };
  useEffect(() => {
    calculateOrderCount()
    getTextSwitcherItems()
  }, [rows, startDate, endDate, dateRangeLabel, initialOrderData])

  const getTextSwitcherItems = () => {
    let pendingOrderCount = 0
    let stockExceedingCount = 0
    let pendingOrdersToBeBulked:manageOrderRowsData[]= []
    initialOrderData.forEach((item) => {
      const creationTime = dayjs(item.creationTime);
      const start = getUTCDate(startDate, "start")
      const end = getUTCDate(endDate, "end")
      const isPendingInTimeRange =
        creationTime.isAfter(dayjs(start)) &&
        creationTime.isBefore(dayjs(end)) &&
        item?.status?.toUpperCase() === "PENDING";

      // // Check if this item exists in rows and is pending
      // const isPendingInRows = rows.some(
      //   (row) =>
      //     row.id === item.id && row.status?.toUpperCase() === "PENDING"
      // );

      if (isPendingInTimeRange) {
        pendingOrderCount += 1;
        pendingOrdersToBeBulked.push(item);
      }

      if (item?.stockQuantityExceed) {
        stockExceedingCount += 1;
      }
    });
    setTextSwitcherItems([
      ...(
        stockExceedingCount > 0 ?
        [{
        label: "Attention:",
        text: `${stockExceedingCount} orders exceed current stock availability. Review and update quickly`,
        svgIcon: "disclaimerIcon",
        itemStyles: {
          container: {
            backgroundColor: "#FFF1F1",
          },
          label: {},
          text: {
            color: "#B54747"
          },
          svg: {
            color: "#B54747",
            width: "1em"
          }
        },
        actionButton: (
          <button
            onClick={(e) => {
              handleSortByStock()
            }
            }
            style={{
              padding: "4px 8px",
              textDecoration: "underline",
              background: "none",
              color: "#1B7713",
              border: "none",
              fontWeight: 600
            }}
          >
            Show Orders
          </button>
        ),
      }]:
      []
      ),
  ...(
    pendingOrderCount > 0
      ? [{
          label: "Quick Action:",
          text: `You’ve ${pendingOrderCount} pending orders to confirm since ${dateRangeLabel}.`,
          svgIcon: "stopWatchSVG",
          itemStyles: {
            container: {
              backgroundColor: "#FFF1FE",
            },
            label: {},
            text: {
              color: "#7B087B"
            },
            svg: {
              width: "1em"
            }
          },
          actionButton: (
            <button
              onClick={(e) => {
                setSelectedFilters({ status: ["PENDING"] });
                handleSetCheckedIdArray(pendingOrdersToBeBulked.map(item => item.id))
                handleBulkInvoiceClick(pendingOrdersToBeBulked)}
              }
              style={{
                padding: "4px 8px",
                textDecoration: "underline",
                background: "none",
                color: "#1B7713",
                border: "none",
                fontWeight: 600
              }}
            >
              {ConfigDictionary?.mergeManageOrderInvoice ? "Invoice all in one click" : "Confirm all in one click"}
            </button>
          ),
        }]
      : []
      ),
    ]);
  }

  const handleSetCheckedIdArray = (ids: any[]) => {
    setCheckedRows(ids);
  };

  const handleStockAllocation = (pendingOrders: manageOrderRowsData[]) => {

    if (pendingOrders.length === 0) {
      setGenericModalProps(
        getGenericModalProps("positive", "Please select at least one pending order to review stock allocation.")
      );
      return;
    }

    navigate("/dashboard/sale/manageStockAllocation", {
      state: { selectedOrders: pendingOrders }
    });
  };

  const handleHideProgress = (progressType: string) => {
    setShowProgress({ ...showProgress, [progressType]: false });
  };
  const showBulkInvoiceProgress = showProgress?.progress || showProgress?.fail;


  const handleBulkInvoiceFilterClick = async (orders: manageOrderRowsData[], filterType: string) => {
    setSelectedFilters({});
    setFilterSearchValue("");
    setIsBulkInvoiceFilterActive(true);
    setSelectedBulkInvoiceFilterType(filterType);
    isBulkPanel.current = true;

    const orderIds: (string | number)[] = Array.isArray(orders)
      ? (orders as manageOrderRowsData[]).map(o => o.id)
      : [];

    // Get currently checked rows and run stock check
    const checkedOrders = rows.filter((row) => checkedRows.includes(row.id));
    const stockCheckOrders = await stockCheckPartialRows(checkedOrders);

    // Keep only those stock-checked orders whose id is in orderIds
    const currentFilterOrders = stockCheckOrders.filter((o: any) => orderIds.includes(o.id));

    // Call filterOrders with ids (not objects)
    filterOrders(currentFilterOrders);

    // Prefer intersection (stock-checked) if non-empty; otherwise use all orderIds
    const filteredRows = currentFilterOrders.length ? currentFilterOrders.map((o: any) => o.id) : orderIds;

    const filterObj = {
      filteredRows,
      filterType,
      isFilterActive: true
    }

    sessionStorage.setItem("bulkInvoiceFilterData", JSON.stringify(filterObj));

    setBulkInvoiceFilteredData(filteredRows);
  }

  const stockCheckPartialRows = async (orders: manageOrderRowsData[]) => {
      let sortedPendingOrders = orders?.filter((order: any) => order?.status?.toUpperCase() === "PENDING") || []
      sortedPendingOrders.sort((a: any, b: any) => {
        const dateA = new Date(a?.creationTime);
        const dateB = new Date(b?.creationTime);
        return dateB.getTime() - dateA.getTime();
      });
      setSortedPendingOrderNumbers(sortedPendingOrders?.map((o: any) => o?.orderNumber) || []);
      let bulkSummary;
      if(ConfigDictionary.useStockValidate) {
        let stockValidateResponse = await getStockValidateResponse(sortedPendingOrders);
        setStockValidateResponse(stockValidateResponse);
        bulkSummary = await calculateBulkInvoiceSummaryUsingStockValidate(sortedPendingOrders, stockValidateResponse)
      } else {
        bulkSummary = await performStockCheckForBulkInvoicing(sortedPendingOrders);
      }
      let orderNumberList = [
        ...(bulkSummary?.parOrders ?? []),
        ...(bulkSummary?.canOrders ?? [])
      ].flatMap(od => od?.orderNumber);
      orders.forEach(node => node.stockQuantityExceed = orderNumberList.includes(node.orderNumber));
      return orders
  }

  return viewBulkConfirm && isBulkOrderConfirmAllowed ? (
    <BulkConfirm
      pending_data={
        Array.isArray(rows)
          ? rows.filter((row) => row.status.toLowerCase() === "pending")
          : []
      }
      startDateV={startDate}
      endDateV={endDate}
      handleToggle={() => setViewBulkConfirm(!viewBulkConfirm)}
      disableStockCheck = {disableStockCheck.current}
      useNewUpdateStatusAPI = {useNewOrderStatusUpdateAPI.current}
    />
  ) : (
    <div className="manage_order_parentV2">
      <ScreenOverlay apply={loader} />

      <CustomBulkModal
        type={genericModalProps?.type}
        message={genericModalProps?.message}
        leftButtonText={genericModalProps?.leftButtonText}
        rightButtonText={genericModalProps?.rightButtonText}
        modalOpen={genericModalProps?.open}
        onLeftButtonClick={genericModalProps?.onLeftButtonClick}
        onRightButtonClick={genericModalProps?.onRightButtonClick}
        onClose={resetGenericModalProps}
        confirmedOrders={skuReplacementConfigValue ? summaryInvoicableCount:  (invoicableOrders.length ?? 0)}
        partiallyConfirmedOrders={skuReplacementConfigValue ? summaryPartiallyInvoicableCount : (partiallyInvoicableOrders.length ?? 0)}
        unavailableOrders={skuReplacementConfigValue ?summaryUnavailableCount :   (unavailableOrders.length ?? 0)}
        showSummary={pendingOrderNumbers.length > 0}
        insideBulkInvoice={true}
        filterConfirmedOrders={() => handleBulkInvoiceFilterClick(invoicableOrders, "Fully Invoiceable Orders") }
        filterPartiallyConfirmedOrders={() => handleBulkInvoiceFilterClick(partiallyInvoicableOrders, "Partially Invoiceable Orders")}
        filterUnavailableOrders={() => handleBulkInvoiceFilterClick(unavailableOrders, "Unfulfillable Orders")}
      />

      {showBulkInvoiceProgress && (
        <BulkProgress
          type={bulkType}
          bulkStatusMap={orderBulkStatusMap}
          showProgress={showProgress}
          handleHideProgress={handleHideProgress}
        />
      )}

      <Snackbar
        open={snackbarOpen}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="info"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Your report will be downloaded shortly.
        </Alert>
      </Snackbar>

      { isBulkInvoiceFilterActive ?
        <FormHeader
          insideManageOrder={true}
          parentLabel={ "Manage Orders" }
          searchFunction={handleSearchValueChange}
          label={`Bulk Invoice - ${selectedBulkInvoiceFilterType}`}
          goBackToParent={async () => 
              {
                isBulkPanel.current=false;
                await initInitialize()
                setSelectedFilters({});
                setFilterSearchValue("");
                sessionStorage.removeItem("bulkInvoiceFilterData");
                setIsBulkInvoiceFilterActive(false)
              }
            } 
        />
      :
      <HeaderV2
        title={"Manage Orders"}
        searchFunction={loader ? () => {} : handleSearchValueChange}
        onRefresh={initInitialize} 
        resetSearch={resetSearch}
        lastRefreshed={lastRefreshed}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        startDate={startDate}
        endDate={endDate}
        setDateRangeLabel={setDateRangeLabel}
      />
      }

      {
        isBulkInvoiceFilterActive ?
        <div style={{display: "flex", alignItems: "flex-end", justifyContent: "space-between"}}>
          <GenericSummaryCard cardTitle='Sales Order Summary' itemObjects={itemObjects.current}/>

          <div style={{display: "flex", gap: "4px", height: "2.6em", width: "100%", justifyContent: "end", maxWidth: "500px"}}>
            <div className="order-status-filters">
              <div
                className="order-status-button"
                onClick={() => {
                  setSelectedFilters({});
                  setFilterSearchValue("");
                }}
                style={{
                  backgroundColor: Object.values(selectedFilters ?? {}).some(
                    (arr) => arr?.length > 0
                  )
                    ? "#FAFAFB" : "#00A392",
                }}
              >
                <span style={{ 
                  color: Object.values(selectedFilters ?? {}).some(
                    (arr) => arr?.length > 0
                  )
                  ? "#7c7c7c" :  "white",
                  lineHeight: 1
                }}>All</span>
              </div>
            </div>
            {multipleCategoryFilterEnabled ? (
              <FormControl className="manage_secondary_orders_filterV2" sx={{
                "& .MuiInputBase-root": {
                  fontSize: "inherit !important",
                  height: "2.6em"
                },
              }}>
                <Select
                  variant="outlined"
                  labelId="dropdown_label"
                  open={multipleFiltersVisible}
                  value={"More Filters"}
                  onOpen={() => {
                    setMultipleFiltersVisible(true);
                    setFilterSearchValue("");
                  }}
                  onClose={() => setMultipleFiltersVisible(false)}
                  renderValue={() => (
                    <span style={{ color: Object.values(selectedFilters)?.some(arr => arr?.length > 0)
                      ? "white"
                      : "#7C7C7C",
                    fontSize: "1em",
                    fontWeight: 500,
                    transition: "background-color 0.3s ease-in-out",  }}
                    className="manage_secondary_orders_filter-labelV2"
                    >
                      More Filters
                    </span>
                  )}
                  sx={{
                    background: Object.values(selectedFilters)?.some(arr => arr?.length > 0)
                      ? "#00A392"
                      : "#FAFAFB",
                    
                    boxSizing: "border-box",
                    height: "30px",
                    width: "100%",
                    borderRadius: "20px",
                    "& .MuiInputBase-root": {
                      fontSize: "inherit !important"
                    },
                    "& .MuiSelect-select": {
                      fontSize: "inherit",
                      height: "30px",
                      padding: "6px 9px",
                      paddingRight: "0px !important",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      color: "#909090",
                      outline: "none",
                      border: "none",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",   // removes border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "& .MuiOutlinedInput-root.Mui-focused": {
                      outline: "none",
                      boxShadow: "none",
                    },
                    "& .MuiSelect-icon": {
                      fontSize: "1em",
                      color: Object.values(selectedFilters)?.some(arr => arr?.length > 0)
                      ? "white"
                      : "#7C7C7C",
                      right: "3px",
                    },
                  }}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "right",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "right",
                    },
                    PaperProps: {
                      sx: {
                        boxShadow: "none",
                        marginTop: "4px",
                        border: "1px solid #DEDEDE",
                      },
                    },
                    MenuListProps: {
                      sx: {
                        paddingTop: "8px",
                        paddingBottom: "0",
                      },
                    },
                  }}
                >
                  <MenuItem
                    key={`filter-${selectedFilterType}-${JSON.stringify(selectedFilters)}`}
                    disableRipple
                    style={{
                      padding: 0,
                      backgroundColor: "transparent",
                      outline: "none",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <div className="MSO_filter-dropdown-containerV2"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="MSO_filter-headerV2">
                        <span className="MSO_filter-nameV2">All Filters</span>
                        <span
                          className={`MSO_filter-clear-allV2 ${
                            (Object.values(selectedFilters).some((arr) => arr.length > 0) || 
                              filterSearchValue) &&
                            `MSO_filter-clear-all_activeV2`
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedFilters({});
                            setFilterSearchValue("");
                            // Clear URL parameters when clearing all filters
                            clearStatusFromURL();
                            setAppliedStatusFromQuery(false);
                          }}
                        >
                          Clear All
                        </span>
                      </div>
                      <div className="MSO_filter_searchBar_containerv2">
                        <div></div>
                        <input
                          id="MSO_fiter_searchBarV2_bulk"
                          className="MSO_fiter_searchBarV2"
                          placeholder="Search..."
                          value={filterSearchValue}
                          onClick={(e) => e.stopPropagation()}
                          onChange={handleFilterSearchValueChange}
                          autoFocus
                          onBlur={(e) => e.target.focus()}
                        />
                      </div>

                      <div className="MSO_filter-optionsV2">
                        <div className="MSO_filter-options-leftV2">
                          {filterKeys.map((key) => (
                            <div
                              key={key}
                              className={`${selectedFilterType === key && `MSO_filterSelected`}`}
                              onClick={(e) => {
                                handleFilterTypeChange(key);
                                e.stopPropagation();
                              }}
                            >
                              {key === "salesRepName"
                                ? "SalesRep"
                                : key === "routeIdAndName"
                                ? "Route"
                                : key === "gstNo"
                                ? "GST Type"
                                : capitalizeFirstLetter(key)} ({(selectedFilters[key] || []).length})
                            </div>
                          ))}
                        </div>
                      <div className="MSO_filter-options-rightV2">
                        {filterKeys.map(
                          (key) =>
                            selectedFilterType === key && (
                              <SimpleBar className="MSO_filter-option-secondaryV2" key={key}>
                                {Object.keys(multipleFiltersList[key] ?? {})
                                  .filter((value) =>
                                    filterSearchValue && typeof value === "string"
                                      ? value.toLowerCase().includes(filterSearchValue.toLowerCase())
                                      : true
                                  )
                                  .map((value) => (
                                    <label
                                      key={value}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        color: "#444444",
                                        fontSize: "13px",
                                      }}
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <input
                                        id="MSO_fiter_searchBarV2_checkbox_bulk"
                                        type="checkbox"
                                        checked={(selectedFilters[key] || []).includes(value)}
                                        onChange={() => handleSelectedFilterChange(key, value)}
                                        style={{ borderColor: "#CBCBCB" }}
                                      />
                                       {key === "source" ? (
                                         `${value.toUpperCase()} (${multipleFiltersList[key]?.[value] || 0})`
                                       ) : (key === "salesRepName" || key === "routeIdAndName") ? (
                                         <Tooltip title={value} arrow>
                                           <span>{`${capitalizeFirstLetter(truncateString(value,20))} (${multipleFiltersList[key]?.[value] || 0})`}</span>
                                         </Tooltip>
                                       ) : key === "gstNo" ? (
                                         `${value.toLowerCase().includes("non") ? "Non-GST Outlet" : "GST Outlet"} (${multipleFiltersList[key]?.[value] || 0})`
                                       ) : (
                                         <Tooltip title={value} arrow>
                                           <span>{`${capitalizeFirstLetter(value)} (${multipleFiltersList[key]?.[value] || 0})`}</span>
                                         </Tooltip>
                                       )}
                                    </label>
                                  ))}
                              </SimpleBar>
                            )
                        )}
                      </div>
                    </div>
                  </div>
                </MenuItem>
              </Select>
            </FormControl>
          ) : (
              <FormControl className="manage_order_filter">
                <span
                  style={{
                    fontSize: "14px",
                    color: "#AFAFAF",
                  }}
                >
                  Filter:
                </span>
                <Select
                  labelId="dropdown_label"
                  value={statusFilter}
                  size="small"
                  sx={{ minWidth: "190px", marginLeft: "10px" }}
                  onChange={(e) => {
                    handleStatusFilterChange(e.target.value);
                  }}
                  renderValue={(selected) => {
                    const item = orderTrackingStagesList.find(
                      (d) => d.id === selected
                    );
                    return item ? (
                      <div className="dropdown_selected_item">
                        {capitalize(item?.dmsLabel ?? "")}
                      </div>
                    ) : null;
                  }}
                >
                  {orderTrackingStagesList.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      <div className="dropdown_menu_item">
                        <span>{capitalize(item?.dmsLabel ?? "")}</span>
                      </div>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </div>
        </div>
        :
      <>
        <GenericSummaryCard cardTitle='Sales Order Summary' itemObjects={itemObjects.current}/>

        <div style={{display: "flex", justifyContent: "space-between", marginTop: "9px"}}>
          <TextSwitcher textSwitcherItems={textSwitcherItems ?? []} interval={3000}/>
          <div style={{display: "flex", gap: "4px", height: "2.6em", width: "100%", justifyContent: "end", maxWidth: "500px"}}>
            <div className="order-status-filters">
              <div
                className="order-status-button"
                onClick={() => {
                  setSelectedFilters({});
                  setFilterSearchValue("");
                }}
                style={{
                  backgroundColor: Object.values(selectedFilters ?? {}).some(
                    (arr) => arr?.length > 0
                  )
                    ? "#FAFAFB" : "#00A392",
                }}
              >
                <span style={{ 
                  color: Object.values(selectedFilters ?? {}).some(
                    (arr) => arr?.length > 0
                  )
                  ? "#7c7c7c" :  "white",
                  lineHeight: 1
                }}>All</span>
              </div>
              {Object.keys(multipleFiltersList["status"] ?? {})
                .slice(0, 4)
                .filter((value) =>
                  filterSearchValue && typeof value === "string"
                    ? value.toLowerCase().includes(filterSearchValue.toLowerCase())
                    : true
                )
                .map((value) => (
                  <div
                    className="order-status-button"
                    onClick={() => handleSelectedFilterChange("status", value)}
                    style={{
                      backgroundColor: (selectedFilters["status"] || []).includes(value)
                        ? "#00A392"
                        : "#FAFAFB",
                    }}
                  >
                    <span style={{ color: (selectedFilters["status"] || []).includes(value) ? "white" : "#7c7c7c", lineHeight: 1,   }}>{capitalizeFirstLetter(value)}</span>
                  </div>
                ))}
            </div>
            {multipleCategoryFilterEnabled ? (
              <FormControl className="manage_secondary_orders_filterV2" sx={{
                "& .MuiInputBase-root": {
                  fontSize: "inherit !important",
                  height: "2.6em"
                },
              }}>
                <Select
                  variant="outlined"
                  labelId="dropdown_label"
                  open={multipleFiltersVisible}
                  value={"More Filters"}
                  onOpen={() => {
                    setMultipleFiltersVisible(true);
                    setFilterSearchValue("");
                  }}
                  onClose={() => setMultipleFiltersVisible(false)}
                  renderValue={() => (
                    <span style={{ color: Object.values(selectedFilters)?.some(arr => arr?.length > 0)
                      ? "white"
                      : "#7C7C7C",
                    fontSize: "1em",
                    fontWeight: 500,
                    transition: "background-color 0.3s ease-in-out",  }}
                    className="manage_secondary_orders_filter-labelV2"
                    >
                      More Filters
                    </span>
                  )}
                  sx={{
                    background: Object.values(selectedFilters)?.some(arr => arr?.length > 0)
                      ? "#00A392"
                      : "#FAFAFB",
                    
                    boxSizing: "border-box",
                    height: "30px",
                    width: "100%",
                    borderRadius: "20px",
                    "& .MuiInputBase-root": {
                      fontSize: "inherit !important"
                    },
                    "& .MuiSelect-select": {
                      fontSize: "inherit",
                      height: "30px",
                      padding: "6px 9px",
                      paddingRight: "0px !important",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      color: "#909090",
                      outline: "none",
                      border: "none",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",   // removes border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "& .MuiOutlinedInput-root.Mui-focused": {
                      outline: "none",
                      boxShadow: "none",
                    },
                    "& .MuiSelect-icon": {
                      fontSize: "1em",
                      color: Object.values(selectedFilters)?.some(arr => arr?.length > 0)
                      ? "white"
                      : "#7C7C7C",
                      right: "3px",
                    },
                  }}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "right",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "right",
                    },
                    PaperProps: {
                      sx: {
                        boxShadow: "none",
                        marginTop: "4px",
                        border: "1px solid #DEDEDE",
                      },
                    },
                    MenuListProps: {
                      sx: {
                        paddingTop: "8px",
                        paddingBottom: "0",
                      },
                    },
                  }}
                >
                  <MenuItem
                    key={`filter-${selectedFilterType}-${JSON.stringify(selectedFilters)}`}
                    disableRipple
                    style={{
                      padding: 0,
                      backgroundColor: "transparent",
                      outline: "none",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <div className="MSO_filter-dropdown-containerV2"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="MSO_filter-headerV2">
                        <span className="MSO_filter-nameV2">All Filters</span>
                        <span
                          className={`MSO_filter-clear-allV2 ${
                            (Object.values(selectedFilters).some((arr) => arr.length > 0) || 
                              filterSearchValue) &&
                            `MSO_filter-clear-all_activeV2`
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedFilters({});
                            setFilterSearchValue("");
                            // Clear URL parameters when clearing all filters
                            clearStatusFromURL();
                            setAppliedStatusFromQuery(false);
                          }}
                        >
                          Clear All
                        </span>
                      </div>
                      <div className="MSO_filter_searchBar_containerv2">
                        <div></div>
                        <input
                          id="MSO_fiter_searchBarV2"
                          className="MSO_fiter_searchBarV2"
                          placeholder="Search..."
                          value={filterSearchValue}
                          onClick={(e) => e.stopPropagation()}
                          onChange={handleFilterSearchValueChange}
                          autoFocus
                          onBlur={(e) => e.target.focus()}
                        />
                      </div>

                      <div className="MSO_filter-optionsV2">
                        <div className="MSO_filter-options-leftV2">
                          {filterKeys.map((key) => (
                            <div
                              key={key}
                              className={`${selectedFilterType === key && `MSO_filterSelected`}`}
                              onClick={(e) => {
                                handleFilterTypeChange(key);
                                e.stopPropagation();
                              }}
                            >
                              {key === "salesRepName"
                                ? "SalesRep"
                                : key === "routeIdAndName"
                                ? "Route"
                                : key === "gstNo"
                                ? "GST Type"
                                : capitalizeFirstLetter(key)} ({(selectedFilters[key] || []).length})
                            </div>
                          ))}
                        </div>
                      <div className="MSO_filter-options-rightV2">
                        {filterKeys.map(
                          (key) =>
                            selectedFilterType === key && (
                              <SimpleBar className="MSO_filter-option-secondaryV2" key={key}>
                                {Object.keys(multipleFiltersList[key] ?? {})
                                  .filter((value) =>
                                    filterSearchValue && typeof value === "string"
                                      ? value.toLowerCase().includes(filterSearchValue.toLowerCase())
                                      : true
                                  )
                                  .map((value) => (
                                    <label
                                      key={value}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        color: "#444444",
                                        fontSize: "13px",
                                      }}
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <input
                                      id="MSO_fiter_searchBarV2_checkbox"
                                        type="checkbox"
                                        checked={(selectedFilters[key] || []).includes(value)}
                                        onChange={() => handleSelectedFilterChange(key, value)}
                                        style={{ borderColor: "#CBCBCB" }}
                                      />
                                       {key === "source" ? (
                                         `${value.toUpperCase()} (${multipleFiltersList[key]?.[value] || 0})`
                                       ) : (key === "salesRepName" || key === "routeIdAndName") ? (
                                         <Tooltip title={value} arrow>
                                           <span>{`${capitalizeFirstLetter(truncateString(value,20))} (${multipleFiltersList[key]?.[value] || 0})`}</span>
                                         </Tooltip>
                                       ) : key === "gstNo" ? (
                                         `${value.toLowerCase().includes("non") ? "Non-GST Outlet" : "GST Outlet"} (${multipleFiltersList[key]?.[value] || 0})`
                                       ) : (
                                         <Tooltip title={value} arrow>
                                           <span>{`${capitalizeFirstLetter(value)} (${multipleFiltersList[key]?.[value] || 0})`}</span>
                                         </Tooltip>
                                       )}
                                    </label>
                                  ))}
                              </SimpleBar>
                            )
                        )}
                      </div>
                    </div>
                  </div>
                </MenuItem>
              </Select>
            </FormControl>
          ) : (
              <FormControl className="manage_order_filter">
                <span
                  style={{
                    fontSize: "14px",
                    color: "#AFAFAF",
                  }}
                >
                  Filter:
                </span>
                <Select
                  labelId="dropdown_label"
                  value={statusFilter}
                  size="small"
                  sx={{ minWidth: "190px", marginLeft: "10px" }}
                  onChange={(e) => {
                    handleStatusFilterChange(e.target.value);
                  }}
                  renderValue={(selected) => {
                    const item = orderTrackingStagesList.find(
                      (d) => d.id === selected
                    );
                    return item ? (
                      <div className="dropdown_selected_item">
                        {capitalize(item?.dmsLabel ?? "")}
                      </div>
                    ) : null;
                  }}
                >
                  {orderTrackingStagesList.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      <div className="dropdown_menu_item">
                        <span>{capitalize(item?.dmsLabel ?? "")}</span>
                      </div>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </div>
        </div>
        
      </>
      }
      {loader ? (
        <Loader sx={{ position: "absolute", top: "55%" }} />
      ) : (
        <CustomDataGrid
          key={"manageOrder"}
          rows={Array.isArray(rows) ? rows : []}
          columnsMetaData={manageOrderColumnsV2MetaData()}
          orderStatusConfig={orderTrackingStagesList}
          redirectUrl="/sale/manageOrders/viewOrder/"
          redirectUrlFunction={handleRedirect}
          tableWidth={0.74}
          downloadSingleReportConfig={downloadSingleReportConfig}
          handleBulkNav={() =>  !orderConfirmationEnabled.current ?  handleBulkInvoiceClick(pendingOrderDataForBulkButton) : setViewBulkConfirm(true)}
          isAnyPendingOrder={
            pendingOrderNumbers.length > 0
          }
          orderSourceConfig={orderSourcesRef.current}
          disableOrderEditDesignationBasedChild={disableOrderEditDesignationBased && isUserAllowedToEdit(orderEditAllowedRoles)}
          enableRowClickRedirect={true}
          orderConfirmationEnabled={orderConfirmationEnabled.current}
          onDownloadGeneric={handleCustomDownload}
          setSortByColumn={setSortByColumn}
          isCheckboxSelection={true}
          setCheckedIdArray={handleSetCheckedIdArray}
          checkedIdArray={checkedRows}
          disabledRowIds={bulkInvoiceStatusMap?.pending || []}
          printInvoicesLoading={printInvoicesLoading}
          printBulkInvoices={() => logLoadTrace(printBulkInvoices, 'bulk_invoice_print_invoices_time')}  
          numberOfSelectedInvoicedOrders={invoiceNumbers.length}
          insideManageOrder={true}
          footerButtonLoading={bulkInvoceInProgress}
          bulkInvoiceButtonLoading={bulkInvoiceButtonLoading}
          handleStockAllocation={() => handleStockAllocation(pendingOrderDataForBulkButton)}
          stockAllocationAllowed={stockAllocationAllowed.current}
          isStockAllocationButtonVisible={!isBulkInvoiceFilterActive}
        />
      )}
    </div>
  );
};

export default ManageSecondaryOrderV2;
